export const POLLING_INTERVAL_MINUTES = 30;
export const MAX_RETRIES = 5;
export const DEACTIVATE_IF_USER_CANCELS = false;
